import { apiKey, culture } from "../constants/common-constants";
import ApiService from "./ApiService";

export default class TestDriveService {
  static getTimeSlots = async (vehicleId) =>
    ApiService.get(`/resources/ownersettings/${vehicleId}?apikey=${apiKey}`);

  static uploadFileAttachments = async (fileName, fileAttachments) => {
    return ApiService.upload(
      `/email/attachments?filename=${fileName}&apikey=${apiKey}`,
      fileAttachments,
    );
  };
  static requestTestDrive = ({
    company,
    consentPrivacyPolicy,
    emailAddress,
    firstName,
    imprintUrl,
    privacyUrl,
    privatPerson,
    lastName,
    telephone,
    town,
    zipCode,
    streetNumber,
    vehicleId,
    testDrive,
  }) => {
    let mappedData = {
      company,
      consentPrivacyPolicy,
      emailAddress,
      firstname: firstName,
      imprintUrl,
      privacyUrl,
      privatPerson,
      culture: culture,
      surname: lastName,
      telephone,
      town,
      zipCode,
      streetNumber,
      vehicleId,
      testDrive,
    };
    return ApiService.post(`/email/sendcart?apikey=${apiKey}`, mappedData);
  };
}
